import { Box, Typography, Grid } from '@mui/material';
import { Card } from '../../../../shared/components/ui/Card';

interface NetworkCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  color: string;
  bgColor: string;
  borderColor: string;
  fullWidth?: boolean;
}

export function NetworkCard({ 
  icon, 
  label, 
  value, 
  color, 
  bgColor, 
  borderColor,
  fullWidth = false 
}: NetworkCardProps) {
  return (
    <Grid item xs={12} sm={6} md={fullWidth ? 12 : 3}>
      <Card sx={{ 
        p: 2, 
        borderRadius: 2, 
        minHeight: 110, 
        background: bgColor, 
        border: `1.5px solid ${borderColor}`, 
        textAlign: 'center', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        gap: 1 
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 0.5 }}>
          {icon}
          <Typography fontSize={15} color={color} fontWeight={700}>{label}</Typography>
        </Box>
        <Typography fontWeight={700} fontSize={20} color={color}>{value}</Typography>
      </Card>
    </Grid>
  );
} 